import { useEffect, type RefObject } from 'react'

/**
 * Вызывает onIntersect, когда элемент попадает в область видимости (с запасом rootMargin).
 * Наблюдатель пересоздаётся при смене enabled/onIntersect: если после подгрузки элемент
 * так и остался на экране, колбэк сработает снова. root — прокручиваемый контейнер,
 * если список прокручивается не вместе со страницей; по умолчанию окно.
 */
export function useOnIntersect(
  ref: RefObject<Element | null>,
  onIntersect: () => void,
  enabled: boolean,
  rootMargin = '300px',
  root?: RefObject<Element | null>,
) {
  useEffect(() => {
    const element = ref.current
    if (!enabled || !element) return
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) onIntersect()
      },
      { rootMargin, root: root?.current ?? null },
    )
    observer.observe(element)
    return () => observer.disconnect()
  }, [ref, onIntersect, enabled, rootMargin, root])
}
